import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            console.warn('Network error:', error.message);
        }
        return Promise.reject(error);
    },
);
